import { userManager } from '../router';
import { useAuthStore } from '@/store/auth';
import { useLoadingStore } from '@/store/loading';
import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://www.iprod.com.ua/identityservice/',
  withCredentials: true,
  headers: {
    accept: 'application/json'
  }
});

instance.interceptors.request.use(
  function (config) {
    const authStore = useAuthStore();
    const token = authStore.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    useLoadingStore().start();
    return config;
  },
  function (error) {
    useLoadingStore().finish();
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

instance.interceptors.response.use(
  (response) => {
    useLoadingStore().finish();
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    useLoadingStore().finish();

    if (!error.response || error.response.status !== 401) {
      return Promise.reject(error);
    }

    if (originalRequest._retry) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({
          resolve: (token) => {
            originalRequest.headers = originalRequest.headers || {};
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            resolve(instance(originalRequest));
          },
          reject: (err) => reject(err)
        });
      });
    }

    isRefreshing = true;

    try {
      const user = await userManager.signinSilent();
      const newToken = user.access_token;

      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers['Authorization'] = 'Bearer ' + newToken;

      processQueue(null, newToken);

      return await instance(originalRequest);
    } catch (err) {
      processQueue(err, null);

      await userManager.signinRedirect();

      return Promise.reject(err);
    } finally {
      isRefreshing = false;
    }
  }
);

export default instance;
